/**
 * 应急指南组件 - Ghost Button 风格
 * 克制的警告提示，不抢视觉重心
 */

import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

interface EmergencyTipsCardProps {
  className?: string;
}

export function EmergencyTipsCard({ className }: EmergencyTipsCardProps) {
  const { t } = useTranslation("assessments");

  const tips = [
    t("carePlan.emergencyTip1"),
    t("carePlan.emergencyTip2"),
    t("carePlan.emergencyTip3"),
    t("carePlan.emergencyTip4"),
  ];

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn(
            "text-destructive hover:text-destructive hover:bg-destructive/10",
            className,
          )}
        >
          <AlertTriangle className="w-4 h-4 mr-2" />
          {t("carePlan.emergencyGuide", "紧急指南")}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            {t("carePlan.emergencyTips", "紧急情况处理指南")}
          </DialogTitle>
          <DialogDescription>
            {t("carePlan.emergencyGuideDesc", "当出现以下情况时的应对措施")}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4 space-y-4">
          {tips.map((tip, index) => (
            <div
              key={index}
              className="flex gap-3 p-3 rounded-lg border bg-card"
            >
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-destructive/10 flex items-center justify-center text-xs font-semibold text-destructive">
                {index + 1}
              </div>
              <p className="text-sm text-foreground flex-1">{tip}</p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default EmergencyTipsCard;
